import React from 'react'
import FadeInContent from '../FadeInContent'
import {
  SideImageWithText,
  ImageWithText,
  CenteredImage,
  VideoWithText,
  ImageLink,
} from '../Slices'

const SliceZone = ({ slices }) => {
  const sliceComponents = {
    sideimage_with_text: SideImageWithText,
    image_with_text: ImageWithText,
    video_with_text: VideoWithText,
    centered_image: CenteredImage,
    image_link: ImageLink,
  }

  return slices.map((slice, index) => {
    const SliceComponent = sliceComponents[slice.type]
    if (SliceComponent) {
      return (
        <FadeInContent key={index}>
          <SliceComponent slice={slice} key={`slice-${index}`} />
        </FadeInContent>
      )
    }
    return null
  })
}

export default SliceZone